import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { frontloadConnect } from 'react-frontload';

import Page from '../../components/page';
import DynamicContent from '../../components/DynamicContent';

import {
  getContentPage,
  getMoreContentPage,
  removeCurrentContent,
} from '../../containers/Content/actions';

import { addProductToCart } from '../../containers/Shop/actions';

import { setLanguage } from '../../containers/Language/actions';

const frontload = async props => {
  const { lang, content, category } = props.match.params;
  const loadContent = content === 'index.html' ? undefined : content;
  const loadLanguage = lang || props.language;
  const loadType = props.type;
  const loadCategory = category;
  await props.getContentPage(loadContent, loadLanguage, loadType, loadCategory);
};

class Content extends Component {
  constructor(props) {
    super(props);
    this.loadMoreContentPage = this.loadMoreContentPage.bind(this);
  }

  componentWillUnmount() {
    this.props.removeCurrentContent();
  }

  shouldComponentUpdate(nextProps) {
    const { content, lang, category, categories } = nextProps.match.params;
    if (
      this.props.match.params.content !== content ||
      this.props.match.params.category !== category
    ) {
      // this.props.removeCurrentContent();
      this.props.getContentPage(
        content,
        lang,
        nextProps.type,
        category,
        categories
      );
    }
    return true;
  }

  loadMoreContentPage(type, page, total) {
    this.props.getMoreContentPage(
      page,
      this.props.language,
      type,
      total,
      this.props.match.params.category,
      this.props.categories
    );
  }

  render() {
    const { content, status } = this.props;

    if (!content || content.length === 0) return <div>Loading ...</div>;
    const yoast_meta = content.yoast_meta;

    return (
      <Page
        id="page_content"
        title={yoast_meta && yoast_meta.yoast_wpseo_title}
        description={yoast_meta && yoast_meta.yoast_wpseo_metadesc}
        link={yoast_meta && yoast_meta.yoast_wpseo_canonical}
        // image={image}
      >
        <DynamicContent
          content={content}
          addProductToCart={this.props.addProductToCart}
          language={this.props.language}
          category={this.props.match.params.category}
          status={status}
          loadMoreContentPage={this.loadMoreContentPage}
          currency={this.props.currency}
          currency_symbol={this.props.currency_symbol}
        />
      </Page>
    );
  }
}

const mapStateToProps = state => ({
  content: state.content.currentContent,
  categories: state.content.categories,
  status: state.content.status,
  contact_fields: state.options.options.contact_fields,
  title_contact: state.options.options.title_contact,
  status_contact: state.options.options.status_contact,
  language: state.language,
  currency: state.shop.currency,
  currency_symbol: state.shop.currency_symbol,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getContentPage,
      setLanguage,
      removeCurrentContent,
      getMoreContentPage,
      addProductToCart,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  frontloadConnect(frontload, {
    onMount: true,
    onUpdate: false,
  })(Content)
);

Content.propTypes = {
  content: PropTypes.any,
};

Content.defaultProps = {
  content: {
    yoast_meta: {},
    acf: {
      content: [],
    },
  },
};
